/**
 * Returns the configured public URL with a safe protocol.
 * Exact local development hosts use HTTP; all other hosts use HTTPS.
 */
export const getBaseUrl = (): string => {
  const url = (
    process.env.NEXT_PUBLIC_BASE_URL ||
    process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL ||
    'http://localhost:3000'
  ).trim()

  try {
    const hasProtocol = url.startsWith('http://') || url.startsWith('https://')
    const parsedUrl = new URL(hasProtocol ? url : `https://${url}`)
    const hostname = parsedUrl.hostname
    const isLoopback =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '[::1]'
    const protocol = isLoopback ? 'http' : 'https'
    const urlWithoutProtocol = url.replace(/^https?:\/\//, '')

    return `${protocol}://${urlWithoutProtocol}`
  } catch {
    return `https://${url.replace(/^https?:\/\//, '')}`
  }
}
